export default "__VITE_ASSET__NCpIZ12sHv86lRyGv6FpEQ__"